import Box from '@mui/material/Box';
// import { headerHeight, headerHeightMb } from '~/styles';
import React from 'react';
import Typography from '@mui/material/Typography';
import { fontSize } from '@mui/system';
import { growth1 } from '~/assets';
import { growth2 } from '~/assets';
import { prediction } from '~/assets';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root:{
    width: 310,
    [theme.breakpoints.up(350)]: {
      width:343
    },
    [theme.breakpoints.up("lg")]: {
      width:350
    },
  }
}))

export const ECard = (props: any) => {
  const classes= useStyles()
  return (
    <>
      <Box
        display={'flex'}
        flexDirection="column"
        // justifyContent="space-around"
        alignItems="center"
        borderRadius="8px"
        height={{md:'524px !important', xs: 'auto'}}
        bgcolor='#141420'
        className={classes.root}
        mb={2}
        marginX={{ lg: props.margin? 5:0, xs:0}}
      >
        <Box
          sx={{
            color: '#fff',
            // fontSize: '30',
            padding: '5px',
            // fontSize: '40px',
          }}
          mt={{lg:4 , xs:3}}
        >
          <Typography fontSize={{lg:'64px', xs: '48px'}} fontWeight={275} lineHeight='110%'>
            {props.title}
          </Typography>
        </Box>
        <Box sx={{ padding: '5px' }}>{props.image}</Box>
        <Box sx={{ color: '#fff', padding: '5px' }}>
          <Typography style={{ fontWeight: 600, fontSize: '20px', lineHeight:'110%'}}>
            {props.subtitle}
          </Typography>
        </Box>
        <Box mb={{lg:0, xs:2}} marginX={2} sx={{ color: '#fff', fontSize: '18', padding: '15px' }}>
          <Typography align="center" variant="body2">
            {props.para}
          </Typography>
        </Box>
      </Box>
    </>
  );
};
